<div class="loader-container" *ngIf="!view">
    <i  class="fas fa-spinner fa-spin"></i>
</div>
<div class="course-select-list" *ngIf="view">
    <div class="right-buttom-menu">
        <p-button variant="text" (click)="courseListCsv()"  severity="link" >
            <i class="far fa-file-export"></i>
            <span style="padding-left: 5px"> Download Course CSV </span>
        </p-button>
    </div>
    <div>
        <app-view [items]="view?.data?.content" [info]="view?.data"></app-view>
        <!-- <div class="course-select-card" *ngFor="let co of view">
            <app-course-card [course]="co"></app-course-card>
        </div> -->
    </div>
</div>

